import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { AuthProvider } from 'auth/JwtContext';
import Router from 'Router';
import { AppWhiteLabelingConfiguration } from 'shared.types';
import { ReactElement } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SnackbarProvider from './components/snackbar';
import { ProgramPassProvider } from 'pages/ProgramPassContext';
import { StripeProvider } from 'pages/StripeContext';

function App({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  whiteLabelingConfig,
}: {
  whiteLabelingConfig: AppWhiteLabelingConfiguration;
}): ReactElement {

  useEffect(() =>
  {
    const queryParams = new URLSearchParams(window.location.search);
    const utmSource = queryParams.get('utm_source');
    const utmMedium = queryParams.get('utm_medium');
    const utmCampaign = queryParams.get('utm_campaign');

    if (utmSource) {
      localStorage.setItem('utm_source', utmSource);
    }
    if (utmMedium) {
      localStorage.setItem('utm_medium', utmMedium);
    }
    if (utmCampaign) {
      localStorage.setItem('utm_campaign', utmCampaign);
    }
  }, []);

  return (
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <CssBaseline />
        <SnackbarProvider>
          <AuthProvider>
            <ProgramPassProvider>
              <StripeProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Router />
                </LocalizationProvider>
              </StripeProvider>
            </ProgramPassProvider>
          </AuthProvider>
        </SnackbarProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
}

export default App;
